module.exports = __webpack_public_path__ + "static/media/baku.202b80a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/baku.jpg
// module id = 38
// module chunks = 0